/* King Kirana Mart – delivery options (Same-day Express / Next-day / Store pickup)
   Cart page + cart drawer picker, holidays, checkout lock, cart attributes, product-page promise. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('kk-delivery-config');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!C.enabled) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var LS_KEY = 'kk-delivery-v1';
  var FEE_ID = Number(C.feeVariantId) || 0;
  var CODE = String(C.code || '').trim();
  var EXPRESS_CUT = Number(C.expressCutoffHour || 18) * 60;
  var EXPRESS_START = (C.expressStartHour === null || C.expressStartHour === undefined || C.expressStartHour === '' ? 9 : Number(C.expressStartHour)) * 60;
  var NEXT_CUT = Number(C.nextCutoffHour || 21) * 60;
  var FEE = Number(C.expressFee || 50);
  var HEAVY = Number(C.heavyKg || 6);
  var PROMISE = String(C.nextPromise || '').trim() || 'after 12 pm';
  var STORES = String(C.pickupStores || '').trim();

  /* ---------- zones & holidays ---------- */
  function pins(s) { return String(s || '').split(/[^0-9]+/).filter(function (p) { return p.length === 6; }); }
  var ZONES = (C.zones || []).map(function (z) {
    return { pins: pins(z.pins), min: +z.min || 0, charge: +z.charge || 0, tier: +z.tier || 0, tierCharge: +z.tierCharge || 0, free: +z.free || 0 };
  }).filter(function (z) { return z.pins.length; });
  function zoneFor(pin) {
    for (var i = 0; i < ZONES.length; i++) if (ZONES[i].pins.indexOf(pin) > -1) return ZONES[i];
    return null;
  }
  // Express PINs: blank setting = every delivery PIN
  var EXPRESS_PINS = pins(C.expressPins);
  function expressHere(pin) { return !EXPRESS_PINS.length || EXPRESS_PINS.indexOf(pin) > -1; }
  function zoneCharge(z, subtotalRs) {
    if (z.free && subtotalRs >= z.free) return 0;
    if (z.tier && subtotalRs >= z.tier) return z.tierCharge;
    return z.charge;
  }

  var HOL = {};
  String(C.holidays || '').split(/\n/).forEach(function (line) {
    var t = line.trim(); if (!t) return;
    var m = t.match(/(\d{4})-(\d{1,2})-(\d{1,2})/), iso;
    if (m) iso = m[1] + '-' + ('0' + m[2]).slice(-2) + '-' + ('0' + m[3]).slice(-2);
    else if ((m = t.match(/(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{4})/))) iso = m[3] + '-' + ('0' + m[2]).slice(-2) + '-' + ('0' + m[1]).slice(-2);
    if (iso) HOL[iso] = t.replace(m[0], '').replace(/^[\s,:\-–]+/, '').trim();
  });

  /* ---------- dates (IST) ---------- */
  var DAY = 864e5;
  function nowIST() {
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    var g = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return +parts[i].value; return 0; };
    return { day: Date.UTC(g('year'), g('month') - 1, g('day')), mins: g('hour') * 60 + g('minute') };
  }
  function iso(ms) { return new Date(ms).toISOString().slice(0, 10); }
  function isOpen(ms) { return !Object.prototype.hasOwnProperty.call(HOL, iso(ms)); }
  function nextOpen(ms) { for (var i = 0; i < 60 && !isOpen(ms); i++) ms += DAY; return ms; }
  var fmt = new Intl.DateTimeFormat('en-IN', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' });
  function label(ms) { return fmt.format(new Date(ms)); }
  function rel(ms, today) {
    if (ms === today) return 'Today, ' + label(ms);
    if (ms === today + DAY) return 'Tomorrow, ' + label(ms);
    return label(ms);
  }
  function left(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    return (h ? h + ' hr ' : '') + (m || !h ? m + ' min' : '');
  }
  function rs(n) { return '₹' + (Math.round(n * 100) / 100).toLocaleString('en-IN'); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- state ---------- */
  var state = { type: null, pin: '' };
  try { var saved = JSON.parse(localStorage.getItem(LS_KEY) || 'null'); if (saved) state = saved; } catch (e) {}
  if (!state.pin && C.customerPin) state.pin = String(C.customerPin).replace(/\D/g, '').slice(0, 6);
  function save() { try { localStorage.setItem(LS_KEY, JSON.stringify(state)); } catch (e) {} }

  var cart = null, plan = null, syncing = null, selfUpdate = false, notice = '';

  function getCart() { return fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return fetch(ROOT + url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }

  /* ---------- planning ---------- */
  function compute(c) {
    var n = nowIST(), today = n.day;
    var items = (c.items || []).filter(function (i) { return i.variant_id !== FEE_ID; });
    var subtotal = items.reduce(function (s, i) { return s + i.final_line_price; }, 0) / 100;
    var grams = items.reduce(function (s, i) { return s + (i.grams || 0) * i.quantity; }, 0);
    var zone = state.pin.length === 6 ? zoneFor(state.pin) : null;
    var pinState = state.pin.length !== 6 ? 'empty' : (zone ? 'ok' : 'none');
    var needMore = zone && subtotal < zone.min ? zone.min - subtotal : 0;

    var p = { today: today, mins: n.mins, empty: !items.length, subtotal: subtotal, kg: grams / 1000, zone: zone, pinState: pinState };

    // Express (same day)
    var exp = { ok: false, why: '' };
    if (!isOpen(today)) { exp.why = 'Closed today' + (HOL[iso(today)] ? ' (' + HOL[iso(today)] + ')' : ''); exp.ws = 'Closed today'; }
    else if (n.mins < EXPRESS_START) { exp.why = 'Available from ' + hour(EXPRESS_START) + ' to ' + hour(EXPRESS_CUT) + '.'; exp.ws = 'From ' + hour(EXPRESS_START); }
    else if (n.mins >= EXPRESS_CUT) { exp.why = 'Available for orders before ' + hour(EXPRESS_CUT) + '. Back tomorrow at ' + hour(EXPRESS_START) + '.'; exp.ws = 'Before ' + hour(EXPRESS_CUT); }
    else if (pinState === 'empty') { exp.why = 'Enter your PIN code'; exp.ws = 'Enter PIN'; }
    else if (pinState === 'none' || !expressHere(state.pin)) { exp.why = 'Same-day Express is not available at this PIN code yet'; exp.ws = 'Not here yet'; }
    else if (needMore) { exp.why = 'Add ' + rs(needMore) + ' more (minimum ' + rs(zone.min) + ')'; exp.ws = 'Min ' + rs(zone.min); }
    else { exp.ok = true; exp.left = EXPRESS_CUT - n.mins; }
    exp.date = today;
    p.express = exp;

    // Next-day
    var base = today + (n.mins < NEXT_CUT ? DAY : 2 * DAY);
    var nd = { date: nextOpen(base), ok: false, why: '' };
    nd.skipped = nd.date !== base;
    if (pinState === 'empty') { nd.why = 'Enter your PIN code'; nd.ws = 'Enter PIN'; }
    else if (pinState === 'none') { nd.why = 'Home delivery not available at this PIN code yet'; nd.ws = 'Not here yet'; }
    else if (needMore) { nd.why = 'Add ' + rs(needMore) + ' more (minimum ' + rs(zone.min) + ')'; nd.ws = 'Min ' + rs(zone.min); }
    else { nd.ok = true; nd.charge = zoneCharge(zone, subtotal); }
    p.next = nd;

    // Pickup
    var pk = (isOpen(today) && n.mins < NEXT_CUT) ? today : nextOpen(today + DAY);
    p.pickup = { ok: true, date: pk };

    // Notes about holidays
    var notes = [];
    if (!isOpen(today)) notes.push('We are closed today' + (HOL[iso(today)] ? ' for ' + HOL[iso(today)] : '') + '. You can still order – it will be delivered on ' + label(nd.date) + '.');
    else if (nd.skipped) {
      var closed = []; for (var d = base; d < nd.date; d += DAY) closed.push(label(d));
      notes.push('We are closed on ' + closed.join(', ') + ', so next-day orders will be delivered on ' + label(nd.date) + '.');
    }
    p.notes = notes;
    return p;
  }
  function hour(mins) { var h = Math.floor(mins / 60), ap = h >= 12 ? 'pm' : 'am'; h = h % 12 || 12; var m = mins % 60; return h + (m ? ':' + ('0' + m).slice(-2) : '') + ' ' + ap; }

  function chosenValid(p) {
    if (!state.type) return false;
    if (state.type === 'express') return p.express.ok;
    if (state.type === 'next') return p.next.ok;
    return true;
  }

  function attrsFor(p) {
    var a = { 'Delivery option': '', 'Delivery date': '', 'Delivery PIN': '', 'Delivery promise': '', _kk_weight_kg: String(Math.round(p.kg * 100) / 100), _kk_heavy: p.kg > HEAVY ? 'yes' : '' };
    if (!state.type || !chosenValid(p)) return a;
    if (state.type === 'express') {
      a['Delivery option'] = 'Same-day Express';
      a['Delivery date'] = iso(p.express.date);
      a['Delivery promise'] = 'Today, ' + label(p.express.date);
    } else if (state.type === 'next') {
      a['Delivery option'] = 'Next-day delivery';
      a['Delivery date'] = iso(p.next.date);
      a['Delivery promise'] = label(p.next.date) + ', ' + PROMISE;
    } else {
      a['Delivery option'] = 'Store pickup';
      a['Delivery date'] = iso(p.pickup.date);
      a['Delivery promise'] = 'Pickup from ' + label(p.pickup.date);
    }
    if (state.type !== 'pickup') a['Delivery PIN'] = state.pin;
    return a;
  }

  /* ---------- sync with cart ---------- */
  var again = false, firstSync = true;
  function sync() {
    if (syncing) { again = true; return syncing; }
    syncing = (function run() {
      return getCart().then(function (c) {
        if (firstSync) {
          firstSync = false;
          var was = (c.attributes || {})['Delivery option'];
          if (!state.type && was) state.type = was === 'Same-day Express' ? 'express' : was === 'Next-day delivery' ? 'next' : was === 'Store pickup' ? 'pickup' : null;
          var wasPin = (c.attributes || {})['Delivery PIN'];
          if (!state.pin && wasPin) state.pin = wasPin;
        }
        var p = compute(c);
        if (state.type && !chosenValid(p)) {
          if (state.type === 'express' && p.pinState === 'ok' && !p.empty) notice = 'Same-day Express is no longer available for this order. Please choose another option.';
          state.type = null; save();
        }
        var fee = null;
        (c.items || []).forEach(function (i) { if (i.variant_id === FEE_ID) fee = i; });
        var wantFee = state.type === 'express' && !p.empty;
        var steps = Promise.resolve(), lineChanged = false;
        if (FEE_ID) {
          if (wantFee && !fee) { lineChanged = true; steps = steps.then(function () { return post('cart/add.js', { items: [{ id: FEE_ID, quantity: 1 }] }); }); }
          else if (!wantFee && fee) { lineChanged = true; steps = steps.then(function () { return post('cart/change.js', { id: fee.key, quantity: 0 }); }); }
          else if (wantFee && fee && fee.quantity !== 1) { lineChanged = true; steps = steps.then(function () { return post('cart/change.js', { id: fee.key, quantity: 1 }); }); }
        }
        var have = (c.discount_codes || []).map(function (d) { return d.code; });
        var codes = have.filter(function (x) { return x.toUpperCase() !== CODE.toUpperCase(); });
        if (wantFee && CODE) codes.push(CODE);
        var codesChanged = codes.join(',').toUpperCase() !== have.join(',').toUpperCase();
        var attrs = attrsFor(p);
        var attrsChanged = Object.keys(attrs).some(function (k) { return (c.attributes || {})[k] !== attrs[k] && !(attrs[k] === '' && !(c.attributes || {})[k]); });
        if (codesChanged || attrsChanged) {
          steps = steps.then(function () {
            var body = { attributes: attrs };
            if (codesChanged) body.discount = codes.join(',');
            return post('cart/update.js', body);
          });
        }
        return steps.then(function () {
          if (lineChanged || codesChanged) return getCart().then(function (c2) { cart = c2; plan = compute(c2); return refreshTheme(true); });
          cart = c; plan = p;
        });
      });
    })().catch(function () {}).then(function () {
      syncing = null; render();
      if (again) { again = false; return sync(); }
    });
    return syncing;
  }

  function refreshTheme(changed) {
    if (!changed) return;
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return new Promise(function () {}); }
    var drawer = document.querySelector('cart-drawer');
    return fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (s) {
      var parse = function (h) { return new DOMParser().parseFromString(h, 'text/html'); };
      if (drawer && s['cart-drawer']) {
        var fresh = parse(s['cart-drawer']).querySelector('#CartDrawer');
        var cur = drawer.querySelector('#CartDrawer');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        drawer.classList.toggle('is-empty', !!(cart && !cart.item_count));
      }
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && s['cart-icon-bubble']) {
        var fb = parse(s['cart-icon-bubble']).querySelector('.shopify-section');
        if (fb) bubble.innerHTML = fb.innerHTML;
      }
      var qn = document.querySelector('.quick-notify');
      if (qn && cart) {
        var sp = qn.querySelectorAll('.notify-leftpart > div > span');
        if (sp[0]) sp[0].textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'Item' : 'Items');
        if (sp[1]) sp[1].textContent = 'Rs. ' + (cart.total_price / 100).toFixed(2);
        if (!cart.item_count) qn.classList.remove('active');
      }
      try {
        if (window.publish && window.PUB_SUB_EVENTS) { selfUpdate = true; publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kk-delivery', cartData: cart }); selfUpdate = false; }
      } catch (e) { selfUpdate = false; }
    }).catch(function () {});
  }

  /* ---------- UI ---------- */
  function skeleton() {
    var el = document.createElement('div');
    el.className = 'kk-dl';
    el.setAttribute('data-kk-dl', '');
    el.innerHTML =
      '<p class="kk-dl__head">Choose how you get your order</p>' +
      '<div class="kk-dl__pin"><label class="kk-dl__pinlabel">Delivery PIN code' +
      '<input class="kk-dl__pininput" type="text" inputmode="numeric" autocomplete="postal-code" maxlength="6" placeholder="e.g. 324005"></label>' +
      '<span class="kk-dl__pinmsg" aria-live="polite"></span></div>' +
      '<div class="kk-dl__nudge" aria-live="polite" hidden></div>' +
      '<div class="kk-dl__opts" role="radiogroup" aria-label="Delivery options"></div>' +
      '<p class="kk-dl__detail" aria-live="polite"></p>' +
      '<div class="kk-dl__notes" aria-live="polite"></div>' +
      '<p class="kk-dl__err" role="alert" hidden>Please choose a delivery option to continue.</p>';
    return el;
  }

  function optHTML(type, title, shortTitle, sub, shortSub, price, ok, why, whyShort) {
    var sel = state.type === type;
    return '<button type="button" class="kk-dl__opt' + (sel ? ' is-on' : '') + (ok ? '' : ' is-off') + '" role="radio" aria-checked="' + sel + '"' + (ok ? '' : ' aria-disabled="true"') + ' data-kk-opt="' + type + '" aria-label="' + esc(title) + '">' +
      '<span class="kk-dl__dot" aria-hidden="true"></span>' +
      '<span class="kk-dl__txt"><span class="kk-dl__title"><span class="kk-dl__tl">' + title + '</span><span class="kk-dl__ts">' + shortTitle + '</span></span>' +
      '<span class="kk-dl__sub">' + (ok ? sub : why) + '</span>' +
      '<span class="kk-dl__subs">' + (ok ? shortSub : (whyShort || why)) + '</span></span>' +
      '<span class="kk-dl__price">' + price + '</span></button>';
  }

  // Lowest paid next-day charge across zones, and the lowest free-delivery threshold
  function minCharge() {
    var m = Infinity;
    ZONES.forEach(function (z) { [z.charge, z.tier ? z.tierCharge : Infinity].forEach(function (c) { if (c > 0 && c < m) m = c; }); });
    return m === Infinity ? 0 : m;
  }
  function minFree() {
    var m = Infinity;
    ZONES.forEach(function (z) { if (z.free && z.free < m) m = z.free; });
    return m === Infinity ? 0 : m;
  }

  // "Add ₹X more" message for next-day delivery
  function nudgeFor(p) {
    if (p.empty) return null;
    var s = p.subtotal;
    if (p.pinState !== 'ok') {
      var f = minFree();
      if (!f) return null;
      if (s >= f) return { html: '🎉 Your order qualifies for <b>FREE next-day delivery</b> in our delivery area', done: true };
      return { html: '🚚 <b>FREE next-day delivery</b> on orders above ' + rs(f) + ' – add ' + rs(f - s) + ' more', pct: Math.min(100, Math.round(s / f * 100)) };
    }
    var z = p.zone;
    if (s < z.min) return null; // minimum-order message is shown on the option itself
    if (!z.free) return null;
    if (s >= z.free) return { html: '🎉 You\'ve unlocked <b>FREE next-day delivery</b>', done: true };
    var now = zoneCharge(z, s), pct = Math.min(100, Math.round(s / z.free * 100));
    if (z.tier && s < z.tier && z.tierCharge < now) {
      return {
        html: '🚚 Add <b>' + rs(z.tier - s) + '</b> more to pay only ' + rs(z.tierCharge) + ' delivery, or <b>' + rs(z.free - s) + '</b> more for <b>FREE</b> delivery',
        short: 'Add ' + rs(z.free - s) + ' more for free delivery',
        pct: pct
      };
    }
    return {
      html: '🚚 Add <b>' + rs(z.free - s) + '</b> more for <b>FREE next-day delivery</b> (save ' + rs(now) + ')',
      short: 'Add ' + rs(z.free - s) + ' more for free delivery',
      pct: pct
    };
  }

  function render() {
    var boxes = document.querySelectorAll('[data-kk-dl]');
    if (!boxes.length || !plan) return;
    var p = plan;
    boxes.forEach(function (box) {
      box.hidden = p.empty;
      var input = box.querySelector('.kk-dl__pininput');
      if (input && document.activeElement !== input && input.value !== state.pin) input.value = state.pin;
      var msg = box.querySelector('.kk-dl__pinmsg');
      if (msg) {
        msg.className = 'kk-dl__pinmsg' + (p.pinState === 'none' ? ' is-bad' : p.pinState === 'ok' ? ' is-good' : '');
        msg.textContent = p.pinState === 'ok' ? 'We deliver here' : p.pinState === 'none' ? 'Home delivery isn\'t available here yet – choose store pickup' : 'Needed for home delivery';
      }
      var ex = p.express, nd = p.next;
      var nudge = nudgeFor(p);
      var nb = box.querySelector('.kk-dl__nudge');
      if (nb) {
        nb.hidden = !nudge;
        if (nudge) {
          nb.className = 'kk-dl__nudge' + (nudge.done ? ' is-done' : '');
          nb.innerHTML = '<span class="kk-dl__nudgetxt">' + nudge.html + '</span>' +
            (nudge.pct != null ? '<span class="kk-dl__bar" aria-hidden="true"><span style="width:' + nudge.pct + '%"></span></span>' : '');
        }
      }
      var exSub ='Delivered today' + (ex.left != null && ex.left <= 180 ? ' – order in ' + left(ex.left) : ' – order before ' + hour(EXPRESS_CUT));
      var ndSub = rel(nd.date, p.today) + ', ' + PROMISE;
      if (nd.ok && nd.charge && nudge && nudge.short) ndSub += '<span class="kk-dl__save">' + nudge.short + '</span>';
      var ndPrice = nd.ok ? (nd.charge ? rs(nd.charge) : '<span class="kk-dl__free">Free</span>') : '';
      if (!nd.ok && p.pinState === 'empty') { nd.why = 'Enter your PIN code to see your charge'; ndPrice = '<span class="kk-dl__from">from ' + rs(minCharge()) + '</span>'; }
      var pkSub = (p.pickup.date === p.today ? 'Ready today' : 'Ready on ' + label(p.pickup.date)) + (STORES ? ' – ' + esc(STORES) : '') + '. Earn King Credits';
      var shortDay = function (d) { return d === p.today ? 'Today' : d === p.today + DAY ? 'Tomorrow' : label(d); };
      box.querySelector('.kk-dl__opts').innerHTML =
        optHTML('express', 'Same-day Express', 'Express', exSub, 'Today', rs(FEE), ex.ok, ex.why, ex.ws) +
        optHTML('next', 'Next-day delivery', 'Next day', ndSub, shortDay(nd.date) + ', ' + PROMISE, ndPrice, nd.ok, nd.why, nd.ws) +
        optHTML('pickup', 'Store pickup', 'Pickup', pkSub, shortDay(p.pickup.date), '<span class="kk-dl__free">Free</span>', true, '');
      var det = box.querySelector('.kk-dl__detail');
      if (det) {
        var dt = '';
        if (state.type === 'express' && ex.ok) dt = 'Same-day Express: delivered today. ' + rs(FEE) + ' replaces the delivery charge.';
        else if (state.type === 'next' && nd.ok) dt = 'Next-day delivery: ' + rel(nd.date, p.today) + ', ' + PROMISE + '.';
        else if (state.type === 'pickup') dt = 'Store pickup: ' + (p.pickup.date === p.today ? 'ready today' : 'ready on ' + label(p.pickup.date)) + (STORES ? ' at ' + STORES : '') + '. Earn King Credits.';
        det.textContent = dt;
        det.hidden = !dt;
      }
      var notes = (notice ? [notice] : []).concat(p.notes);
      box.querySelector('.kk-dl__notes').innerHTML = notes.map(function (t) { return '<p class="kk-dl__note">' + esc(t) + '</p>'; }).join('');
      if (state.type) box.querySelector('.kk-dl__err').hidden = true;
    });
  }

  function mount() {
    var targets = [];
    document.querySelectorAll('cart-drawer .cart__ctas, #main-cart-rightpart .cart__ctas').forEach(function (t) { targets.push(t); });
    if (!targets.length) { var b = document.getElementById('checkout'); if (b) targets.push(b); }
    var added = false;
    targets.forEach(function (t) {
      var prev = t.previousElementSibling;
      if (prev && prev.hasAttribute('data-kk-dl')) return;
      t.parentNode.insertBefore(skeleton(), t);
      added = true;
    });
    if (added) render();
    return targets.length;
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('[data-kk-opt]');
    if (opt) {
      e.preventDefault();
      if (opt.getAttribute('aria-disabled') === 'true') {
        if (plan && plan.pinState !== 'ok' && opt.getAttribute('data-kk-opt') !== 'pickup') {
          var inp = opt.closest('[data-kk-dl]').querySelector('.kk-dl__pininput'); if (inp) inp.focus();
        }
        return;
      }
      notice = '';
      state.type = opt.getAttribute('data-kk-opt'); save();
      render(); sync();
      return;
    }
    var co = e.target.closest && e.target.closest('[name="checkout"], #CartDrawer-Checkout, #checkout');
    if (co && document.querySelector('[data-kk-dl]')) {
      e.preventDefault(); e.stopImmediatePropagation();
      var go = function () {
        if (!plan || !state.type || !chosenValid(plan)) {
          document.querySelectorAll('[data-kk-dl]').forEach(function (box) {
            var er = box.querySelector('.kk-dl__err');
            er.hidden = false;
            er.textContent = !state.type ? 'Please choose a delivery option to continue.' : 'Please choose another delivery option – the one you picked is no longer available.';
          });
          var vis = Array.prototype.filter.call(document.querySelectorAll('[data-kk-dl]'), function (b) { return b.offsetParent; })[0];
          if (vis) vis.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        co.setAttribute('aria-busy', 'true');
        window.location.href = ROOT + 'checkout';
      };
      sync().then(go);
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !(f.id === 'cart' || f.id === 'CartDrawer-Form')) return;
    var sub = e.submitter;
    if (sub && sub.name !== 'checkout' && sub.id !== 'CartDrawer-Checkout') return;
    if (!document.querySelector('[data-kk-dl]')) return;
    e.preventDefault();
  }, true);

  var pinTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.classList || !e.target.classList.contains('kk-dl__pininput')) return;
    var v = e.target.value.replace(/\D/g, '').slice(0, 6);
    if (v !== e.target.value) e.target.value = v;
    document.querySelectorAll('.kk-dl__pininput').forEach(function (i) { if (i !== e.target) i.value = v; });
    state.pin = v; save();
    clearTimeout(pinTimer);
    if (v.length === 6 || v.length === 0) pinTimer = setTimeout(function () { if (cart) { plan = compute(cart); render(); } sync(); }, 150);
    else if (cart) { plan = compute(cart); render(); }
  });

  // Re-mount when the drawer re-renders; re-check when the cart changes
  var moTimer;
  new MutationObserver(function () {
    clearTimeout(moTimer);
    moTimer = setTimeout(function () { if (mount() && !cart && !syncing) sync(); }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
  try {
    if (window.subscribe && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, function () { if (!selfUpdate) setTimeout(sync, 50); });
  } catch (e) {}
  document.addEventListener('visibilitychange', function () { if (!document.hidden && document.querySelector('[data-kk-dl]')) sync(); });
  setInterval(function () { if (document.querySelector('[data-kk-dl]') && cart) { var before = plan && plan.express.ok; plan = compute(cart); render(); if (before && !plan.express.ok && state.type === 'express') sync(); } }, 60000);

  /* ---------- product page promise ---------- */
  function promiseText() {
    var n = nowIST(), today = n.day;
    if (isOpen(today) && n.mins >= EXPRESS_START && n.mins < EXPRESS_CUT) {
      return '<b>Same-day delivery in Kota</b> – order within ' + left(EXPRESS_CUT - n.mins) + ' (' + rs(FEE) + ' Express)';
    }
    var base = today + (n.mins < NEXT_CUT ? DAY : 2 * DAY), d = nextOpen(base);
    var when = d === today + DAY ? 'tomorrow (' + label(d) + ')' : 'on ' + label(d);
    var pre = n.mins < NEXT_CUT && isOpen(today) ? 'Order before ' + hour(NEXT_CUT) + ', get it ' : 'Order now, get it ';
    return '<b>' + pre + when + ' ' + PROMISE + '</b> – delivery in Kota';
  }
  function productPromise() {
    if (!C.productPromise || !document.body.classList.contains('page-product')) return;
    var main = document.querySelector('main') || document;
    var form = main.querySelector('form[action*="/cart/add"] [name="add"]');
    if (!form || /same-day-express-delivery/.test(location.pathname)) return;
    var anchor = form.closest('.product-form__buttons') || form.parentElement;
    if (!anchor || anchor.parentNode.querySelector('.kk-dl-promise')) return;
    var el = document.createElement('p');
    el.className = 'kk-dl-promise';
    el.innerHTML = '<span aria-hidden="true">🚚</span><span class="kk-dl-promise__t"></span>';
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
    var upd = function () { el.querySelector('.kk-dl-promise__t').innerHTML = promiseText(); };
    upd(); setInterval(upd, 60000);
  }

  function start() { mount(); productPromise(); if (document.querySelector('[data-kk-dl]')) sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
